import {
  WIDGET_UP,
  WIDGET_GET,
  WIDGET_DOWN,
  WIDGET_UPDATE
} from '../constants/actionTypes';
import { moveElementPosition } from '../utils/splices';

export const initialState = {
  widgetList: []
};

export default (state = initialState, action) => {
  const { type, position } = action;
  const { widgetList } = state;
  switch (type) {
    case WIDGET_UP: {
      if (position > 0) {
        const newList = [
          ...moveElementPosition(widgetList, position, position - 1)
        ];
        return { ...state, widgetList: newList };
      }
      return state;
    }

    case WIDGET_DOWN: {
      if (position < widgetList.length - 1) {
        const newList = [
          ...moveElementPosition(widgetList, position, position + 1)
        ];
        return { ...state, widgetList: newList };
      }
      return state;
    }
    case WIDGET_GET:
      return {
        ...state,
        widgetList: action.widgetList
      };
    case WIDGET_UPDATE:
      return { ...state, widgetList: action.widgetList };
    default:
      return state;
  }
};
